import { z } from 'zod';

/** 24-char hex Mongo ObjectId string */
export const mongoObjectIdString = z.string().regex(/^[0-9a-fA-F]{24}$/, 'form.validation.invalidId');

/**
 * Accepts '', null, undefined as cleared; otherwise validates ObjectId string.
 */
export const optionalMongoObjectId = z.preprocess(
    (v) => (v === '' || v === null || v === undefined ? undefined : v),
    mongoObjectIdString.optional(),
);

/** Same empty-to-undefined coerce, but the id itself is required after coerce. */
export const requiredMongoObjectId = z.preprocess(
    (v) => (v === '' || v === null || v === undefined ? undefined : v),
    mongoObjectIdString,
);
